(function () {
  'use strict';

  class QuantitySelector {
    constructor(container) {
      this.init(container);
    }

    setup() {
      this.validate();

      this.changeEvent = new Event('change', { bubbles: true });
      this.DOM.qtyDecrease.addEventListener('click', this._handleDecrease);
      this.DOM.qtyIncrease.addEventListener('click', this._handleIncrease);
      this.DOM.qtyValue.addEventListener('change', this._handleChange);
    }

    getQuantity() {
      return parseInt(this.DOM.qtyValue.value);
    }

    destroy() {
      if (this.DOM) {
        this.DOM.qtyDecrease.removeEventListener('click', this._handleDecrease);
        this.DOM.qtyIncrease.removeEventListener('click', this._handleIncrease);
        this.DOM.qtyValue.removeEventListener('change', this._handleChange);

        this.DOM = undefined;
      }
    }

    init(container = document) {
      const qtySelector = container.querySelector('.js-quantity-selector');

      if (qtySelector) {
        this.DOM = {};
        this.DOM.qtySelector = qtySelector;
        this.DOM.qtyDecrease = this.DOM.qtySelector.querySelector('.js-quantity-selector-decrease');
        this.DOM.qtyIncrease = this.DOM.qtySelector.querySelector('.js-quantity-selector-increase');
        this.DOM.qtyValue = this.DOM.qtySelector.querySelector('.js-quantity-selector-value');

        this._handleDecrease = (e) => {
          e.preventDefault();
          const previousValue = this.DOM.qtyValue.value;

          if (parseInt(this.DOM.qtyValue.dataset.min) > parseInt(this.DOM.qtyValue.step) && this.DOM.qtyValue.value == 0) {
            this.DOM.qtyValue.value = this.DOM.qtyValue.dataset.min;
          } else {
            this.DOM.qtyValue.stepDown();
          }

          if (previousValue !== this.DOM.qtyValue.value) this.DOM.qtyValue.dispatchEvent(this.changeEvent);
        };

        this._handleIncrease = (e) => {
          e.preventDefault();
          const previousValue = this.DOM.qtyValue.value;
          this.DOM.qtyValue.stepUp();
          if (previousValue !== this.DOM.qtyValue.value) this.DOM.qtyValue.dispatchEvent(this.changeEvent);
        };

        this._handleChange = () => {
          this.validate();
          if (this.DOM.qtyValue.value < parseInt(this.DOM.qtyValue.dataset.min)) {
            this.DOM.qtyValue.value = this.DOM.qtyValue.dataset.min;
          }
        };

        this.validate = () => {
          const quantityValue = parseInt(this.DOM.qtyValue.value);
          if (this.DOM.qtyValue.min) {
            this.DOM.qtyDecrease.classList.toggle('is-disabled', quantityValue <= parseInt(this.DOM.qtyValue.dataset.min));
          }
        };

        this.setup();
      }
    }
  }

  window.Universe.QuantitySelector = QuantitySelector;
})();
